// The service team. The list pages on the server (filters and search are
// query params), so the store keeps the current page and the paging numbers.
import {
  listMembers,
  createMember,
  updateMember,
  deleteMember,
  getReroutePreview,
} from '../../api/coLiving/team';

export const state = {
  members: [],
  meta: { page: 1, pageSize: 10, total: 0 },
  uiFlags: { isFetching: false },
};

export const getters = {
  getMembers: s => s.members,
  getMeta: s => s.meta,
  getUiFlags: s => s.uiFlags,
};

export const mutations = {
  setMembers(s, { results, page, page_size: pageSize, total }) {
    s.members = results;
    s.meta = { page, pageSize, total };
  },
  setUiFlag(s, { key, value }) {
    s.uiFlags = { ...s.uiFlags, [key]: value };
  },
};

// Only the latest list request may write the list (see coLivingTickets).
let latestListRequest = 0;

export const actions = {
  async fetchMembers({ commit }, query) {
    latestListRequest += 1;
    const request = latestListRequest;
    commit('setUiFlag', { key: 'isFetching', value: true });
    try {
      const { data } = await listMembers(query);
      if (request === latestListRequest) commit('setMembers', data);
      return data;
    } finally {
      if (request === latestListRequest) {
        commit('setUiFlag', { key: 'isFetching', value: false });
      }
    }
  },
  // The caller refetches with its own filters, so the writes only return the
  // API's answer (a PUT carries `visits_flagged` and `reroute`).
  async addMember(_, fields) {
    const { data } = await createMember(fields);
    return data;
  },
  async editMember(_, { id, fields }) {
    const { data } = await updateMember(id, fields);
    return data;
  },
  async removeMember(_, id) {
    await deleteMember(id);
  },
  async fetchReroutePreview(_, id) {
    const { data } = await getReroutePreview(id);
    return data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
